module.exports = __webpack_public_path__ + "static/grafika1@2x-578a3d41de643ed7575759af9be46aa4.png";